import React, { FC } from 'react';
import { TrendLine } from 'common/components/TrendLine';
import { ChangeArrow } from 'entities/MonitorSales/components/ChangeArrow';

interface IComponentProps {
  data?: number[];
  label?: string;
}

export const SummaryTrendRow: FC<IComponentProps> = ({ data = [], label }) => {
  const trendUp = data.length >= 2 && data[data.length - 1] >= data[data.length - 2];

  return (
    <div className="mb-4 ms-summary__sparkline">
      <TrendLine data={data} label={label} />
      <ChangeArrow up={trendUp} />
    </div>
  );
};
